<div class="layout-query">
  <div class="query-form">
    <ebw-monorepo-sidebar-header [icon]="'table'" [title]="title" [isSvg]="false">
    </ebw-monorepo-sidebar-header>
    <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="tabClick($event)">
      <mat-tab [disabled]="(tabIndex == 1 && query)">
        <ng-template mat-tab-label>
          {{'map.sidebar.query.query_standard' | translate}}
        </ng-template>
      </mat-tab>
      <mat-tab [disabled]="(tabIndex == 0 && query)">
        <ng-template mat-tab-label>
          {{'map.sidebar.query.query_advanced' | translate}}
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <ebw-monorepo-query-form *ngIf="showHtml" [dataset]="dataset" [config]="config" [query]="query"
      [advanced]="tabIndex == 1" [datasetList]="datasets">
    </ebw-monorepo-query-form>
  </div>
  <div class="query-action">
    <div class="row">
      <div class="col">
        <button mat-flat-button color="primary" class="w-100" (click)="saveQuery()">
          <span>Salva</span>
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <button mat-flat-button color="accent" class="w-100" (click)="deleteQuery(id,query.query_name)"
          [disabled]="!id">
          <span>Elimina</span>
        </button>
      </div>
      <div class="col">
        <button mat-flat-button color="accent" class="w-100" [disabled]="!id" (click)="queryExec()">
          <span>Esegui Query</span>
        </button>
      </div>
    </div>
  </div>
</div>
